import { useState } from 'react';
import { Button, Box, Container, Divider, Grid, Typography, Dialog, DialogTitle, DialogContent, CircularProgress } from '@mui/material';
import AttachFileRoundedIcon from '@mui/icons-material/AttachFileRounded';
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { FormProvider, RHFSelect, RHFTextField } from './hook-form';
import { ContactSchema } from '../utils/SchemaValidation';
import { contactTypes } from '../utils/Constants';
import { BaseAPI } from '../utils/Api';
import Notification from '../utils/Notification';

const AppFooter = () => {
  const [open, setOpen] = useState(false);
  const [fileName, setFileName] = useState(null);
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const defaultValues = {
    name: '',
    email: '',
    requestType: '',
    details: '',
  };

  const methods = useForm({
    resolver: yupResolver(ContactSchema),
    defaultValues,
  });

  const {
    reset,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const handleFileUploadChange = (e) => {
    setLoading(true);
    setFileName(e.target.files[0].name);
    let formData = new FormData();

    formData.append('attach_file', e.target.files[0]);

    BaseAPI.post('/upload/files/public', formData)
      .then((res) => {
        setFile(res.data.data.url);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => setLoading(false));
  };

  const onSubmit = async (data) => {
    const body = {
      name: data.name,
      email: data.email,
      subject: data.requestType,
      details: data.details,
    };
    if (file) {
      body.attachment = file;
    }
    BaseAPI.post('/ticket', body)
      .then(() => {
        setOpen(false);
        Notification('Message sent successfully', 'success');
        reset();
        setFileName('');
      })
      .catch((err) => {
        Notification(err?.response?.data?.message, 'error');
      });
  };

  return (
    <footer>
      <Box px={{ xs: 3, sm: 5 }} py={{ xs: 5, sm: 5 }} mt={10} bgcolor='#455a64' color='#eceff1'>
        <Container maxWidth='lg'>
          <Grid container spacing={5}>
            <Grid item xs={12} md={6}>
              <Typography variant='subtitle1' className='bold' color='#cfd8dc'>
                Contact Us
              </Typography>
              <Typography color='#cfd8dc' variant='body1'>
                1/2, Kaderabad Housing
              </Typography>
              <Typography color='#cfd8dc' variant='body1'>
                Mohammadpur, Dhaka
              </Typography>
              <Typography color='#cfd8dc' variant='body1'>
                hello.nanosoft@gmail.com
              </Typography>
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography variant='h5' color='#cfd8dc'>
                Got any problem or any request?
              </Typography>
              <br />
              <Button variant='contained' color='secondary' disableElevation size='large' onClick={() => setOpen(true)}>
                Give us a knock!
              </Button>
            </Grid>
          </Grid>
          <Divider color='#0e151e' sx={{ my: 3 }} />
          <Grid container spacing={5}>
            <Grid item xs={12} sm={4}>
              <Box borderBottom={1} mb={1}>
                Links
              </Box>
              <Box>
                <Typography variant='subtitle1' color='#cfd8dc' component={Link} to='/support' className='link'>
                  Terms & Condition
                </Typography>
              </Box>
              <Box>
                <Typography variant='subtitle1' color='#cfd8dc' component={Link} to='privacy-policy' className='link'>
                  Privacy Policy
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box borderBottom={1} mb={1}>
                Account
              </Box>
              <Box>
                <Typography variant='subtitle1' color='#cfd8dc' component={Link} to='login' className='link'>
                  Login
                </Typography>
              </Box>
              <Box>
                <Typography variant='subtitle1' color='#cfd8dc' component={Link} to='register' className='link'>
                  Register
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box borderBottom={1} mb={1}>
                Follow Us On
              </Box>
              <Typography variant='subtitle1' color='#cfd8dc' className='link'>
                Facebook
              </Typography>
              <Typography variant='subtitle1' color='#cfd8dc' className='link'>
                Support
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Give us a message</DialogTitle>
        <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <RHFTextField name='name' label='Name' />
            <RHFTextField name='email' label='Email' />
            <RHFSelect name='requestType' label='Request Type' placeholder='Select your request type'>
              <option value='' />
              {contactTypes.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </RHFSelect>
            <RHFTextField name='details' label='Message' multiline rows={4} />
            <Button component='label' startIcon={<AttachFileRoundedIcon />}>
              {fileName ? fileName : 'Attach File'}
              <input hidden multiple type='file' onChange={handleFileUploadChange} />
            </Button>

            <Button type='submit' fullWidth variant='contained' disableElevation color='primary' disabled={isSubmitting || loading} sx={{ mt: 3 }}>
              {isSubmitting || loading ? <CircularProgress size={24} color='primary' /> : 'Send Message'}
            </Button>
          </DialogContent>
        </FormProvider>
      </Dialog>
    </footer>
  );
};

export default AppFooter;
